var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.749,
    height: 8.744,
    viewBox: "0 0 8.749 8.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M8.429,3.32,5.664.554a1.826,1.826,0,0,0-2.578,0L.32,3.32A1.086,1.086,0,0,0,0,4.093V7.672A1.094,1.094,0,0,0,1.094,8.765H7.655A1.094,1.094,0,0,0,8.749,7.672V4.093A1.086,1.086,0,0,0,8.429,3.32ZM5.468,8.036H3.281V6.6a1.094,1.094,0,1,1,2.187,0ZM8.02,7.672a.365.365,0,0,1-.365.365H6.2V6.6a1.823,1.823,0,1,0-3.645,0V8.036H1.094a.365.365,0,0,1-.365-.365V4.093a.367.367,0,0,1,.107-.258L3.6,1.071a1.1,1.1,0,0,1,1.547,0L7.913,3.836a.367.367,0,0,1,.107.257Z",
    transform: "translate(0 -0.021)",
    fill: "#ad5eff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0a30b4849af3ed84498ddadde0a1f52b.svg";
export { ForwardRef as ReactComponent };